import { DoBoxEntryKind, type InboxEntry } from '@this+that/models';

import { isFreshInsert, isOpen } from './entryInsertPredicates';

interface ApprovalViewer {
  userId?: string | null;
}

export function isQualifyingApprovalInsert(
  entry: InboxEntry,
  { userId }: ApprovalViewer,
): boolean {
  if (!userId) return false;
  return (
    entry.entryKind === DoBoxEntryKind.APPROVAL &&
    entry.flowApproval?.ownerUserId === userId &&
    isFreshInsert(entry) &&
    isOpen(entry)
  );
}
